<script setup>
import { rangeBefore, isAfter, formatRange } from '@/utils/date';
import { computed } from 'vue';
import FordButton from '@/components/FordButton.vue';
import InPersonVirtualTemplate from '@/components/events/InPersonVirtualTemplate.vue';
import RichText from '@/components/pages/RichText.vue';
import DateInfo from '@/components/events/DateInfo.vue';
import InfoItem from '@/components/events/InfoItem.vue';
import CountdownTimer from '@/components/events/countdown/CountdownTimer.vue';

const props = defineProps({
  event: Object,
  currentTime: Object,
});

const withinFifteenMinutes = computed(() => rangeBefore(15, 'minute')(props.event?.startDateTime)(props.currentTime));
const afterStartTime = computed(() => isAfter(props.event?.startDateTime)(props.currentTime));
const showJoinButtons = computed(
  () => withinFifteenMinutes.value
    || afterStartTime.value,
);

const emit = defineEmits(['join']);
</script>
<template>
<in-person-virtual-template :event="event">
  <template v-slot:hero-details>
    <div>{{ formatRange(event?.startDateTime)(event?.endDateTime)}}</div>
    <div>{{ event?.time }}</div>
    <div class="mb-[1.5rem]" v-if="event?.duration">Duration: {{ event?.duration }}</div>
    <div class="mb-[1.5rem]"
      v-if="
        event?.location
        && event?.typeEvent.name !== 'IN-PERSON/VIRTUAL'
        && event?.typeEvent.name !== 'VIRTUAL'
      ">
      {{ event?.location }}</div>
  </template>
  <template v-slot:hero-button>
    <ford-button v-if="showJoinButtons"
      @method="() => emit('join')"
      invert min-width="190" class="opacity-[.85]">
      Join
    </ford-button>
  </template>
  <template v-slot:info-details>
    <date-info
      class="mb-[2rem]"
      :startDateTime="event?.startDateTime"
      :endDateTime="event?.endDateTime"
      show-day-of-week
    />
    <info-item v-if="event?.duration"
      class="mb-[2rem]" label="Time">
      <p>{{ event?.time }}</p>
      <p>{{ event?.duration }}</p>
    </info-item>
    <info-item v-if="event?.location"
      label="Location" :value="event?.location" />
  </template>
  <template v-slot:info-area-additional>
    <div class="tablet:row-start-1 tablet:col-span-2">
      <rich-text :content="event?.waitingRoomDescription"
              class="
                mb-[2rem]
              "
            />
      <countdown-timer
        class="mb-8"
        :currentTime="currentTime" :endTime="event?.startDateTime" />
      <ford-button v-if="showJoinButtons"
        class="mb-[2rem]"
        ariaLabel="Register for the Event"
        @method="() => emit('join')"
        >
        Join</ford-button>
    </div>
  </template>
  <template v-slot:info-area-button>
    <div></div>
  </template>
</in-person-virtual-template>
</template>
